// src/com/tsr/TsrPrintExpress.js
import React, {useEffect} from 'react';
import TopHomeplusPng from '../../asset/image/top_homeplus.png';
import {
    tsrDateTime, tsrLetter, tsrNumber, TsrPageStyle, tsrStoreIdPlusVehPlates, TsrStyles, tsrTemperature
} from './TsrStyle';


/**
 * Express 센터의 TSR 장표를 출력합니다.
 * TsrMain에서 호출됩니다.
 * @param {*} param0 
 * @returns 
 */
export default function TsrPrintExpress({tsrData}) {
    const printedRef = React.useRef(false);

    useEffect(() => {
        //document.body.style = import('../../asset/css/NT_TrailerSeal.css');
        document.title = "(EXP)TSR 장표발행";
    }, []);

    useEffect(()=>{
        if(tsrData.storeId) {
            window.JsBarcode('#barcode',tsrStoreIdPlusVehPlates(tsrData),{
                format: "CODE128",
                lineColor: "#000",
                width: 1,
                height: 20,
                displayValue: false
            });
            /* if(!printedRef.current) {
                window.print();
                printedRef.current = true;
            } */
        }
    }, [tsrData]);

    const renderSeal = (sealNo) => {
        return (
            <ol className="seal_box">
                {
                    Array.from({length: 5}, (v, k) => k).map((idx) => {
                        return <li key={idx}>{tsrLetter(sealNo,idx)}</li>
                    })
                }
            </ol>
        );
    };

    return (
        <div size="A4" style={TsrPageStyle}>
            {/* Title */}
            <div className="tsr_title" style={{verticalAlign: 'bottom'}}>
                <div style={{width: '50mm'}}><img alt="홈플러스 로고" src={TopHomeplusPng} style={{width:'100px'}}/></div>
                <div className="text_trailer" style={{width:'100mm', textAlign:'center'}}>TRAILER SEAL RECORD</div>
                <div className="border_box" style={{width:'55mm', height:'4mm'}}>배차구분 : {tsrData.transType}</div>
            </div>{/* <!-- 헤더 (출발지) --> */}
            <div className="tsr_box" style={TsrStyles.noTopMargin}>
                <div className="red_box" style={{
                    width: '50mm',
                    height: '4mm',
                    fontSize: '16px',
                    verticalAlign: 'middle',
                }}>출발지: {tsrData.dcName}</div>
                <div style={{width:"23mm"}}></div>
                <div className="border_box" style={TsrStyles.div60x4}>차종 : {tsrData.vehTypeName}</div>
                <div className="border_box" style={TsrStyles.div65x4}>상차완료 : {tsrDateTime(tsrData.loadEnTime)}</div>
            </div>
            {/* <!-- 헤더 (도착지)  --> */}
            <div className="tsr_box" style={TsrStyles.noTopMargin}>
                <div className="black_box" style={{
                    width: '50mm', height: '12mm', display: 'inline-table',
                }}><div className="arrive_text">{tsrData.storeName}<br/>({tsrData.storeId})</div></div>
                <div className="black_box" style={{
                    width: '20mm', height: '12mm', display: 'inline-table',
                }}><div className="arrive_text">{tsrData.hocha} 호</div></div>
                <div className="border_box" style={TsrStyles.div60x4}>차량번호 : {tsrData.vehPlates}</div>
                <div className="border_box" style={TsrStyles.div65x4}>출발예정 : {tsrDateTime(tsrData.prosDptrTime)}</div>
                <div className="border_box" style={TsrStyles.div60x4}>운행기사 : {tsrData.driverName}</div>
                <div className="black_box" style={TsrStyles.div65x4}>도착예정 : {tsrDateTime(tsrData.prosArrTime)}</div>
            </div>
            {/* <!-- 주소 / 전화번호   --> */}
            <div className="tsr_box">
                도착지 주소 : {tsrData.storeAddr}
            </div>
            <div style={{fontSize: '13px'}}>
                전화번호 : {tsrData.storeOfficeTelno}
            </div>

            {/* <!-- 봉인번호  "text-align: center;margin-top: 2mm;"  --> */}
            <div className="tsr_box tsr_sub_t">
                <div className="tsr_sub_t_text">■ 봉인번호(Seal Number)</div>
                <div className="tsr_sub_t_box">
                    {tsrData.bindStores ? tsrData.bindStores.map((store) => store.storeName).join(">>"):null}
                </div>
                <div style={{width: '145mm', marginTop: '1mm'}}>
                    {renderSeal(tsrData.sealNo1)}
                    {renderSeal(tsrData.sealNo2)}
                    {renderSeal(tsrData.sealNo3)}
                    <div className="dot_box"><span>봉인부착</span></div>
                    <div className="dot_box"><span>봉인부착</span></div>
                    <div className="dot_box"><span>봉인부착</span></div>
                </div>
                {/* <!-- 점포명 / 봉인번호 확인 서명  --> */}
                <div style={{width: '60mm'}}>
                    <div className="tsr_sub_t_text">■ 점포명/봉인번호 확인 서명</div>
                    <div className="border_box" style={{height:'19mm'}}><br/>
                        운행기사 : <div style={TsrStyles.divSign}></div>&nbsp;(서명)<br/><br/><br/>
                        점포담당 : <div style={TsrStyles.divSign}></div>&nbsp;(서명)
                    </div>
                </div>
                <div style={{textAlign: 'center', marginTop: '2mm'}}>
                    ※ 봉인 개봉 전 점포명과 봉인번호를 다시 한번 확인하시기 바라며 이상 없을 시 서명하여 주시기 바랍니다.
                </div>
            </div>

            <div className="tsr_box" style={TsrStyles.noTopMargin}>
                {/* <!-- 물류집기 출고 현황  --> */}
                <div className="tsr_sub_t_text">■ 물류집기 출고 현황</div>
                <table className="out_f_table" style={{marginTop: '2mm'}}>
                    <tbody>
                    <tr>
                        <td style={{width:'23mm', fontSize:'12px'}}>격실구분</td>
                        <td colSpan="3">전면</td>
                        <td colSpan="3">중면</td>
                        <td colSpan="5">후면</td>
                        <td colSpan="5" rowSpan="2">합계</td>
                        <td colSpan="4" rowSpan="2">기타</td>
                    </tr>
                    <tr>
                        <td style={TsrStyles.font12px}>출발온도</td>
                        <td colSpan="3" className="out_f_text">{tsrTemperature(tsrData.tempF)}</td>
                        <td colSpan="3" className="out_f_text">{tsrTemperature(tsrData.tempM)}</td>
                        <td colSpan="5" className="out_f_text">{tsrTemperature(tsrData.tempR)}</td>
                    </tr>
                    <tr>
                        <td style={TsrStyles.font12px}>물류집기</td>
                        <td>돌리</td>
                        <td>카트</td>
                        <td style={TsrStyles.font11px}>Roll Cage</td>
                        <td>돌리</td>
                        <td>카트</td>
                        <td style={TsrStyles.font11px}>Roll Cage</td>
                        <td>돌리</td>
                        <td>카트</td>
                        <td style={TsrStyles.font11px}>Roll Cage</td>
                        <td>KPP</td>
                        <td>AJU</td>
                        <td>돌리</td>
                        <td>카트</td>
                        <td style={TsrStyles.font11px}>Roll Cage</td>
                        <td>KPP</td>
                        <td>AJU</td>
                        <td style={TsrStyles.font11px}>담배(보루)</td>
                        <td style={TsrStyles.font11px}>양곡(포대)</td>
                        <td style={TsrStyles.font11px}>제지류(타)</td>
                        <td>MU</td>
                    </tr>
                    <tr>
                        <td style={TsrStyles.font12px}>상차수량</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFDolly)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFDollycart)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFRoll)}</td>
                        
                        <td className="t_td_cell">{tsrNumber(tsrData.eMDolly)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eMDollycart)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eMRoll)}</td>
                        
                        <td className="t_td_cell">{tsrNumber(tsrData.eRDolly)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eRDollycart)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eRRoll)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eRPalKpp)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eRPalAju)}</td>
                        
                        <td className="t_td_cell">{tsrNumber(tsrData.eFDolly + tsrData.eMDolly + tsrData.eRDolly)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFDollycart + tsrData.eMDollycart + tsrData.eRDollycart)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFRoll + tsrData.eMRoll + tsrData.eRRoll)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFPalKpp + tsrData.eMPalKpp + tsrData.eRPalKpp)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eFPalAju + tsrData.eFPalAju + tsrData.eRPalAju)}</td>
                        
                        <td className="t_td_cell">{tsrNumber(tsrData.eCigar)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eCorn)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.ePulp)}</td>
                        <td className="t_td_cell">{tsrNumber(tsrData.eMu)}</td>
                        </tr>
                        </tbody>
                    </table>
            </div>

            <div className="tsr_box">
                {/* <!-- 비고    --> */}
                <div style={{width: "209mm"}}>
                    <div className="tsr_sub_t_text" style={{width:'25mm',height:'4mm',float:'left'}}>■ 비고</div>
                    <div className="border_box" style={{width:'179.5mm', height:'4mm'}}>{tsrData.note}</div>
                    <div className="tsr_sub_t_text" style={{
                        width: '25mm', height: '4mm', maxHeight: '10mm', float: 'left',
                    }}>■ 특이사항</div>
                    <div className="border_box" style={{
                        width: '179.5mm', height: '4mm', maxHeight: '10mm',
                    }}>{tsrData.memo}</div>
                </div>	
            </div>
            {/* <!-- 물류차량 시간 관리 / 출발 봉인번호   --> */}
            <div className="tsr_box border_box" style={{width: '206mm', marginTop: '2mm'}}>
                <div style={{width: '128mm'}}>
                    {/* <!-- 도착지 명     --> */}
                    <div style={{width:'79mm', marginTop: '0mm', float: 'left'}}>
                        <div className="black_box" style={{
                            width: '70mm',
                            fontSize: '15px',
                            verticalAlign: 'middle',
                            padding: '3mm',
                            fontWeight: 'bold',
                            margin: '0mm',
                        }}>도착지 : {tsrData.storeName}({tsrData.storeId})</div>
                        <div className="dot_box" style={{width:'37mm', height:'40mm', margin:'0mm'}}><span>온도 기록지</span></div>
                        <div className="dot_box" style={{width:'37mm', height:'40mm'}}><span>물류집기라벨</span></div>
                    </div>
                    
                    <div style={{width:'48mm', marginTop: '0mm' }}>
                        <div className="tsr_sub_t_text" style={TsrStyles.width40mm}>■ 물류차량 시간관리</div>
                        <table style={TsrStyles.topMargin2mm}>
                            <tbody>
                            <tr>
                                <td style={{padding:'1mm', height:'5mm'}}>점포도착시간</td>
                                <td style={{padding:'1mm'}}>점포출발시간</td>
                            </tr>
                            <tr>
                                <td style={{height:'14mm'}}>:</td>
                                <td>:</td>
                            </tr>
                            </tbody>
                        </table>
                        <div>
                            <div className="tsr_sub_t_text" style={TsrStyles.width40mm}>■ 출발 봉인번호</div>
                            <ol className="seal_box" style={TsrStyles.topMargin2mm}><li></li><li></li><li></li><li></li><li></li></ol>
                            <div className="dot_box"><span>봉인부착</span></div>
                        </div>
                    </div>
                    
                    {/* <!-- 정보  "margin-top:2mm;width:77mm"  --> */}
                    <div className="tsr_info" style={TsrStyles.topMargin2mm}>
                        <label style={TsrStyles.topMargin1mm}>1.점포담당자는 봉인(Seal) 개봉 전 봉인번호를 다시 한번 확인하시기 바랍니다.</label><br/>
                        <label style={TsrStyles.topMargin1mm}>2.점포담당자는 물류차량의 도착온도, 도착시간, 출발시간을정확히 기록하여 주시기 <br/>&nbsp;&nbsp;&nbsp;바랍니다.</label><br/>
                        <label style={TsrStyles.topMargin1mm}>3.물류집기 라벨은 물류집기 수불관리의 근거가 되는 자료를 집기 손실에 대한 배상 등 <br/>
                        &nbsp;&nbsp;&nbsp;추후 불이이익 발생될 수 있으니 점포 담당자는 반드시 물류집기 입고 및 반납 수량 확인<br/>
                        &nbsp;&nbsp;&nbsp;후	서명하시기 바랍니다.</label>
                    </div> 
                </div>
                
                <div style={{width:'76mm'}}>
                    <div className="tsr_sub_t_text">■ 점간 이동 현황</div>
                    <table className="move_E_table" style={{marginTop:'2mm', width:'77mm'}}>
                        <tbody>
                        <tr>
                            <td>물류집길</td>
                            <td>돌리</td>
                            <td>카트</td>
                            <td>롤케이지</td>
                            <td>MU</td>
                        </tr>
                        <tr>
                            <td>수 량</td>
                            <td className="value_td"></td>
                            <td className="value_td"></td>
                            <td className="value_td"></td>
                            <td className="value_td"></td>
                        </tr>
                        </tbody>
                    </table>
                    
                    <div className="tsr_sub_t_text" style={{width:'76mm'}}>■ 물류집기 반납현황 <label className="small_text">(점포에서 물류센터로)</label></div>
                    <table className="move_E_table" style={{marginTop:'2mm', width:'77mm'}}>
                        <tbody>
                        <tr>
                            <td>물류집길</td>
                            <td>돌리</td>
                            <td>카트</td>
                            <td>롤케이지</td>
                            <td>MU</td>
                        </tr>
                        <tr>
                            <td>수 량</td>
                            <td className="value_td"></td>
                            <td className="value_td"></td>
                            <td className="value_td"></td>
                            <td className="value_td"></td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="up_info_text small_text" style={{fontWeight:'normal'}}>'물류집기 손실발생시 배상의 책임이 있습니다.'</div>

                    {/* <!-- 특이사항     --> */}
                    <div style={{width:'55mm', marginTop:'2mm', marginLeft:'2mm'}}>
                        <div className="tsr_sub_t_text">■ 특이사항 <label className="small_text">(점간대출입 내역 등)</label></div>
                        <div className="underbar_line" style={{
                            textAlign: 'right', width: '75mm', height: '5mm',
                        }}></div>
                    </div>
                    
                    {/* <!-- 보냉커버 사용/냉동 이상여부 확인 서명  --> */}
                    <div style={{width:'55mm', marginTop:'0mm', marginLeft:'2mm'}}>
                        <div className="tsr_sub_t_text" style={{width: '75mm'}}>■ 보냉커버 사용/냉동 이상여부 확인 서명</div>
                        <div className="underbar_line" style={{
                            textAlign: 'right', width: '75mm', height: '5mm',
                        }}></div>
                    </div>
                    
                    {/* <!-- 운행기사/ 점포담당자 사인  --> */}
                    <div style={{
                        width: '76mm', marginTop: '4mm', marginLeft: '2mm',
                    }}>
                        운행기사 : <div className="underbar_line" style={{width:'48mm', height:'4mm'}}></div>(서명)<br/><br/>
                        점포담당 : <div className="underbar_line" style={{width:'48mm', height:'4mm'}}></div>(서명)
                    </div>
                </div>

            </div>
            {/* <!--  "position:absolute;width:20mm; float:right"   --> */}
            <div style={{
                textAlign: 'left', marginTop: '2mm', marginLeft: '6mm', width: '200mm',
            }}>
                ※ 운송기사는 운송 중 적재물의 분실, 파손, 화재 등 일체의 피해와 정비분량 등으로 인한 입고지연 및 안전사고 발생 시 담당자에게 연락하시기 바랍니다.
            </div>
            
            <div>
                <div className="tsr_sub_t_text" style={{width:'65mm'}}>■ 운영사 : {tsrData.comAgentName} {tsrData.comOfficeTel}</div>
                <div className="tsr_sub_t_text" style={{width:'80mm', float:'right'}}>■ 물류센터 운송 : {tsrData.dcStaffName}             {tsrData.dcOfficeTelno}</div>
                <div className="tsr_sub_t_text" style={{width:'20mm', float:'right'}}>{tsrStoreIdPlusVehPlates(tsrData)}</div>
                
                <div className="tsr_sub_t_text" style={{
                    position: 'absolute', width: '20mm', float: 'right',
                }}><svg id="barcode"></svg></div>
            </div>
 
        </div>
    )
}